const prepareFontVariantsString = (variants) =>
  variants
    .map((variant) => variant.replace('regular', '400').replace('italic', 'i'))
    .filter((variant) => /\d/.test(variant))
    .join(',');

export default prepareFontVariantsString;
